/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Background_Settings_TitleInputs */

const en_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background Settings`)
};

const fr_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres d'arriere-plan`)
};

const de_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundeinstellungen`)
};

const it_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di sfondo`)
};

const ru_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки фона`)
};

const es_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de fondo`)
};

const zh_cn2_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景设置`)
};

const ja_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景設定`)
};

const hi_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पृष्ठभूमि सेटिंग्स`)
};

const pt_pt2_image_export_background_settings_title = /** @type {(inputs: Image_Export_Background_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de fundo`)
};

/**
* | output |
* | --- |
* | "Background Settings" |
*
* @param {Image_Export_Background_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_background_settings_title = /** @type {((inputs?: Image_Export_Background_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Background_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_background_settings_title(inputs)
	if (locale === "de") return de_image_export_background_settings_title(inputs)
	if (locale === "it") return it_image_export_background_settings_title(inputs)
	if (locale === "ru") return ru_image_export_background_settings_title(inputs)
	if (locale === "es") return es_image_export_background_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_background_settings_title(inputs)
	if (locale === "ja") return ja_image_export_background_settings_title(inputs)
	if (locale === "hi") return hi_image_export_background_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_background_settings_title(inputs)
	return en_image_export_background_settings_title(inputs)
});